import type { ApolloError } from '@apollo/client';
import React from 'react';
import * as styles from './IntegrationMentionError.module.scss';
import { INSTALLABLE_PLATFORM_INFO_MAP } from './IntegrationPlatformInfo';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import useIntegrationErrorHandlerData from '../editor/useIntegrationErrorHandlerData';

interface IntegrationMentionErrorProps {
  type: string;
  refetch: () => unknown;
  error: ApolloError;
}

const IntegrationMentionError = ({
  type,
  refetch,
  error,
}: IntegrationMentionErrorProps) => {
  const { handlerProps, errorCode, platform } = useIntegrationErrorHandlerData({
    mode: 'mention',
    type,
    view: 'hoverCard',
    refetch,
    error,
    buttonVariant: 'secondary',
  });

  if (errorCode && platform) {
    const { icon } = INSTALLABLE_PLATFORM_INFO_MAP[platform] ?? {};

    if (handlerProps) {
      return (
        <div className={styles.error}>
          {icon && (
            <div className={styles.icon}>
              <ExternalBrandLogo {...icon} height={24} />
            </div>
          )}
          <div className={styles.title}>{handlerProps.title}</div>
          <div>{handlerProps.message}</div>
          {handlerProps.primaryButton && (
            <div className={styles.button}>{handlerProps.primaryButton}</div>
          )}
        </div>
      );
    }
  }
  return null;
};

export default IntegrationMentionError;
